/**
 * ══════════════════════════════════════════════════════════
 *  OUTFIT — Langues du monde (50+ langues)
 *  Détection automatique via expo-localization + store region
 * ══════════════════════════════════════════════════════════
 */

/* ─── Clés de traduction communes à tous les écrans ─────── */
export const TRANSLATION_KEYS = [
  /* Navigation */
  'nav_home','nav_looks','nav_wardrobe','nav_alerts','nav_profile',
  'nav_travel',
  /* Greetings */
  'good_morning','good_afternoon','good_evening',
  /* Occasions */
  'occ_evening','occ_dinner','occ_casual','occ_work','occ_date','occ_travel',
  /* Home */
  'look_of_day','suggestions','compatibility','perfect','excellent','good',
  'ai_tip','complete_outfit','see_all','missing_pieces','full_wardrobe','to_buy',
  /* Suggestions */
  'budget','no_limit','no_looks_budget','remove_filter','all_occasions',
  /* Wardrobe */
  'my_wardrobe','pieces','search_item','add_item','all_categories',
  'cat_dresses','cat_tops','cat_jackets','cat_bottoms','cat_shoes',
  'cat_bags','cat_accessories','cat_jewelry','cat_swimwear','cat_sportswear',
  /* Travel Wardrobe */
  'travel_wardrobe','my_trips','new_trip','trip_name','destination',
  'departure','return_date','packed_items','outfit_suggestions',
  'weather_dest','add_to_bag','whats_in_my_bag','travel_looks',
  'pack_light','dont_forget','trip_style','days_count',
  /* Cart */
  'my_cart','subtotal','shipping','free_shipping','total',
  'secure_payment','order_now','delivery_address','empty_cart',
  /* Notifications */
  'alerts_stock','notifications','my_alerts','mark_all_read',
  'back_in_stock','price_drop','low_stock','view_item','add_to_cart',
  'watch_item','in_stock','out_of_stock',
  /* Profile */
  'my_profile','member_since','settings','language','currency',
  'region','sign_out',
  /* Common */
  'loading','cancel','confirm','save','edit','delete','close','back',
  'search','filter','sort','share',
];

/* ─── 50+ langues supportées ─────────────────────────────── */
export const WORLD_LANGUAGES = {
  /* ── Europe Occidentale ─────────────────────────────── */
  'fr':    { name: 'Français',          nativeName: 'Français',          flag: '🇫🇷', rtl: false, region: 'EU' },
  'en':    { name: 'English',           nativeName: 'English',            flag: '🇬🇧', rtl: false, region: 'GLOBAL' },
  'es':    { name: 'Spanish',           nativeName: 'Español',            flag: '🇪🇸', rtl: false, region: 'EU' },
  'it':    { name: 'Italian',           nativeName: 'Italiano',           flag: '🇮🇹', rtl: false, region: 'EU' },
  'de':    { name: 'German',            nativeName: 'Deutsch',            flag: '🇩🇪', rtl: false, region: 'EU' },
  'pt':    { name: 'Portuguese',        nativeName: 'Português',          flag: '🇵🇹', rtl: false, region: 'EU' },
  'pt-BR': { name: 'Portuguese (BR)',   nativeName: 'Português (Brasil)', flag: '🇧🇷', rtl: false, region: 'AM' },
  'nl':    { name: 'Dutch',             nativeName: 'Nederlands',         flag: '🇳🇱', rtl: false, region: 'EU' },
  'sv':    { name: 'Swedish',           nativeName: 'Svenska',            flag: '🇸🇪', rtl: false, region: 'EU' },
  'no':    { name: 'Norwegian',         nativeName: 'Norsk',              flag: '🇳🇴', rtl: false, region: 'EU' },
  'da':    { name: 'Danish',            nativeName: 'Dansk',              flag: '🇩🇰', rtl: false, region: 'EU' },
  'fi':    { name: 'Finnish',           nativeName: 'Suomi',              flag: '🇫🇮', rtl: false, region: 'EU' },
  'pl':    { name: 'Polish',            nativeName: 'Polski',             flag: '🇵🇱', rtl: false, region: 'EU' },
  'cs':    { name: 'Czech',             nativeName: 'Čeština',            flag: '🇨🇿', rtl: false, region: 'EU' },
  'ro':    { name: 'Romanian',          nativeName: 'Română',             flag: '🇷🇴', rtl: false, region: 'EU' },
  'hu':    { name: 'Hungarian',         nativeName: 'Magyar',             flag: '🇭🇺', rtl: false, region: 'EU' },
  'el':    { name: 'Greek',             nativeName: 'Ελληνικά',           flag: '🇬🇷', rtl: false, region: 'EU' },
  'uk':    { name: 'Ukrainian',         nativeName: 'Українська',         flag: '🇺🇦', rtl: false, region: 'EU' },
  'ru':    { name: 'Russian',           nativeName: 'Русский',            flag: '🇷🇺', rtl: false, region: 'EU' },
  'tr':    { name: 'Turkish',           nativeName: 'Türkçe',             flag: '🇹🇷', rtl: false, region: 'EU' },
  /* ── Moyen-Orient & Afrique du Nord ─────────────────── */
  'ar':    { name: 'Arabic',            nativeName: 'العربية',            flag: '🇸🇦', rtl: true,  region: 'ME' },
  'fa':    { name: 'Persian (Farsi)',   nativeName: 'فارسی',              flag: '🇮🇷', rtl: true,  region: 'ME' },
  'he':    { name: 'Hebrew',            nativeName: 'עברית',              flag: '🇮🇱', rtl: true,  region: 'ME' },
  'ur':    { name: 'Urdu',              nativeName: 'اردو',               flag: '🇵🇰', rtl: true,  region: 'ME' },
  /* ── Asie du Sud ─────────────────────────────────────── */
  'hi':    { name: 'Hindi',             nativeName: 'हिन्दी',              flag: '🇮🇳', rtl: false, region: 'AS' },
  'bn':    { name: 'Bengali',           nativeName: 'বাংলা',              flag: '🇧🇩', rtl: false, region: 'AS' },
  'ta':    { name: 'Tamil',             nativeName: 'தமிழ்',              flag: '🇮🇳', rtl: false, region: 'AS' },
  'te':    { name: 'Telugu',            nativeName: 'తెలుగు',             flag: '🇮🇳', rtl: false, region: 'AS' },
  /* ── Asie du Sud-Est ─────────────────────────────────── */
  'id':    { name: 'Indonesian',        nativeName: 'Bahasa Indonesia',   flag: '🇮🇩', rtl: false, region: 'SEA' },
  'ms':    { name: 'Malay',             nativeName: 'Bahasa Melayu',      flag: '🇲🇾', rtl: false, region: 'SEA' },
  'th':    { name: 'Thai',              nativeName: 'ภาษาไทย',            flag: '🇹🇭', rtl: false, region: 'SEA' },
  'vi':    { name: 'Vietnamese',        nativeName: 'Tiếng Việt',         flag: '🇻🇳', rtl: false, region: 'SEA' },
  'tl':    { name: 'Filipino',          nativeName: 'Filipino',           flag: '🇵🇭', rtl: false, region: 'SEA' },
  'km':    { name: 'Khmer',             nativeName: 'ខ្មែរ',               flag: '🇰🇭', rtl: false, region: 'SEA' },
  'my':    { name: 'Burmese',           nativeName: 'မြန်မာဘာသာ',        flag: '🇲🇲', rtl: false, region: 'SEA' },
  /* ── Asie de l'Est ───────────────────────────────────── */
  'zh-CN': { name: 'Chinese (Simplified)',  nativeName: '简体中文',       flag: '🇨🇳', rtl: false, region: 'CN' },
  'zh-TW': { name: 'Chinese (Traditional)',nativeName: '繁體中文',        flag: '🇹🇼', rtl: false, region: 'TW' },
  'zh-HK': { name: 'Chinese (HK)',     nativeName: '繁體中文 (香港)',     flag: '🇭🇰', rtl: false, region: 'HK' },
  'ja':    { name: 'Japanese',          nativeName: '日本語',             flag: '🇯🇵', rtl: false, region: 'JP' },
  'ko':    { name: 'Korean',            nativeName: '한국어',              flag: '🇰🇷', rtl: false, region: 'KR' },
  'mn':    { name: 'Mongolian',         nativeName: 'Монгол',             flag: '🇲🇳', rtl: false, region: 'AS' },
  /* ── Afrique subsaharienne ───────────────────────────── */
  'sw':    { name: 'Swahili',           nativeName: 'Kiswahili',          flag: '🇰🇪', rtl: false, region: 'AF' },
  'am':    { name: 'Amharic',           nativeName: 'አማርኛ',              flag: '🇪🇹', rtl: false, region: 'AF' },
  'yo':    { name: 'Yoruba',            nativeName: 'Yorùbá',             flag: '🇳🇬', rtl: false, region: 'AF' },
  'ha':    { name: 'Hausa',             nativeName: 'Hausa',              flag: '🇳🇬', rtl: false, region: 'AF' },
  'zu':    { name: 'Zulu',              nativeName: 'isiZulu',            flag: '🇿🇦', rtl: false, region: 'AF' },
  /* ── Amériques ───────────────────────────────────────── */
  'es-419':{ name: 'Spanish (Latin Am)', nativeName: 'Español (América)', flag: '🌎', rtl: false, region: 'AM' },
  'qu':    { name: 'Quechua',           nativeName: 'Runa Simi',          flag: '🇵🇪', rtl: false, region: 'AM' },
  /* ── Océanie ─────────────────────────────────────────── */
  'mi':    { name: 'Māori',             nativeName: 'Te Reo Māori',       flag: '🇳🇿', rtl: false, region: 'OC' },
};

/* ─── Map locale système → langue Outfit ─────────────────── */
export const SYSTEM_LOCALE_MAP = {
  'fr': 'fr', 'fr-FR': 'fr', 'fr-BE': 'fr', 'fr-CH': 'fr', 'fr-CA': 'fr',
  'en': 'en', 'en-US': 'en', 'en-GB': 'en', 'en-AU': 'en', 'en-CA': 'en', 'en-SG': 'en',
  'es': 'es', 'es-ES': 'es', 'es-MX': 'es-419', 'es-AR': 'es-419', 'es-CO': 'es-419',
  'it': 'it', 'it-IT': 'it',
  'de': 'de', 'de-DE': 'de', 'de-AT': 'de', 'de-CH': 'de',
  'pt': 'pt', 'pt-PT': 'pt', 'pt-BR': 'pt-BR',
  'nl': 'nl', 'nl-NL': 'nl', 'nl-BE': 'nl',
  'sv': 'sv', 'no': 'no', 'da': 'da', 'fi': 'fi',
  'pl': 'pl', 'cs': 'cs', 'ro': 'ro', 'hu': 'hu', 'el': 'el',
  'uk': 'uk', 'ru': 'ru', 'tr': 'tr',
  'ar': 'ar', 'ar-SA': 'ar', 'ar-AE': 'ar', 'ar-EG': 'ar',
  'fa': 'fa', 'he': 'he', 'ur': 'ur',
  'hi': 'hi', 'bn': 'bn', 'ta': 'ta', 'te': 'te',
  'id': 'id', 'ms': 'ms', 'th': 'th', 'vi': 'vi', 'tl': 'tl',
  'zh': 'zh-CN', 'zh-Hans': 'zh-CN', 'zh-CN': 'zh-CN',
  'zh-Hant': 'zh-TW', 'zh-TW': 'zh-TW', 'zh-HK': 'zh-HK',
  'ja': 'ja', 'ko': 'ko',
  'sw': 'sw', 'am': 'am', 'yo': 'yo',
};

/* ─── Langues avec traductions complètes intégrées ──────── */
/* IMPORTANT : cette liste DOIT correspondre exactement aux blocs présents
   dans src/locales/translations.js. Si vous ajoutez une langue dans
   translations.js, ajoutez-la ici aussi. Inversement, ne mettez pas une
   langue ici si elle n'est pas dans translations.js (sinon l'utilisateur
   peut la sélectionner et tomber sur du français/anglais en fallback). */
export const FULLY_TRANSLATED = ['fr', 'en', 'es', 'it', 'de', 'pt-BR', 'ar', 'ru', 'tr'];

/* ─── Langues utilisant l'anglais comme fallback ─────────── */
export function getFallbackLang(lang) {
  if (FULLY_TRANSLATED.includes(lang)) return lang;
  // Aliases : variantes régionales → langue principale traduite
  if (lang === 'pt')      return 'pt-BR';   // Portugais EU → BR (closest)
  if (lang === 'es-419')  return 'es';      // Espagnol Amérique latine → ES
  if (lang === 'es-MX')   return 'es';
  if (lang === 'es-AR')   return 'es';
  if (lang && lang.startsWith('en-')) return 'en';
  if (lang && lang.startsWith('fr-')) return 'fr';
  if (lang && lang.startsWith('de-')) return 'de';
  if (lang === 'no' || lang === 'nb' || lang === 'nn' || lang === 'sv' || lang === 'da' || lang === 'fi') return 'en';
  // Tout le reste → anglais (langue universelle de fallback)
  return 'en';
}

/* ─── Détecter la langue depuis expo-localization ─────────── */
export function detectLanguageFromDevice(locales) {
  if (!locales) return 'en';
  // Convertir en array si ce n'est pas déjà le cas
  var arr = Array.isArray(locales) ? locales : (locales.length ? Array.from(locales) : []);
  if (!arr.length) return 'en';
  for (var i = 0; i < arr.length; i++) {
    var locale = arr[i];
    if (!locale) continue;
    var lang = locale.languageTag || locale.languageCode;
    if (!lang) continue;
    if (SYSTEM_LOCALE_MAP[lang]) return SYSTEM_LOCALE_MAP[lang];
    var short = lang.split('-')[0];
    if (SYSTEM_LOCALE_MAP[short]) return SYSTEM_LOCALE_MAP[short];
  }
  return 'en';
}

/* ─── Détecter la langue depuis la région du store ─────────── */
export function detectLanguageFromRegion(regionCode) {
  const map = {
    FR: 'fr', BE: 'fr', CH: 'fr', LU: 'fr', MC: 'fr',
    DE: 'de', AT: 'de',
    IT: 'it', ES: 'es', PT: 'pt', NL: 'nl',
    SE: 'sv', NO: 'no', DK: 'da', FI: 'fi',
    PL: 'pl', CZ: 'cs', RO: 'ro', HU: 'hu', GR: 'el',
    UA: 'uk', RU: 'ru', TR: 'tr',
    SA: 'ar', AE: 'ar', EG: 'ar', MA: 'ar', KW: 'ar', QA: 'ar',
    IR: 'fa', IL: 'he', PK: 'ur',
    IN: 'hi', BD: 'bn', LK: 'ta',
    ID: 'id', MY: 'ms', TH: 'th', VN: 'vi', PH: 'tl',
    CN: 'zh-CN', TW: 'zh-TW', HK: 'zh-HK', MO: 'zh-HK',
    JP: 'ja', KR: 'ko',
    KE: 'sw', TZ: 'sw', ET: 'am', NG: 'yo', ZA: 'zu',
    BR: 'pt-BR', MX: 'es-419', AR: 'es-419', CO: 'es-419',
    US: 'en', GB: 'en', CA: 'en', AU: 'en', NZ: 'en', SG: 'en',
  };
  return map[regionCode] || 'en';
}
